import { useState } from 'react';
import { makeStyles, Paper } from '@material-ui/core';

import { Product } from '../../../products/types/product.type';
import { Basket } from '../../../baskets/types/basket.type';
import { CatalogProductsList } from '../../../shared/components/Catalog/CatalogProductsList.component';
import { CatalogBasketsList } from '../../../shared/components/Catalog/CatalogBasketsList.component';
import TabsController from '../../../shared/components/Tabs/ButtonTabsController';
import { AddVirtualProductForm } from '../Forms/AddVirtualProductForm.component';
import { OrderItem } from '../../types/order-item.type';

type VirtualToAdd = Omit<OrderItem, 'productId' | 'photo'>;

const TAB_IDS = {
  PRODUCTS: 'products',
  BASKETS: 'baskets',
} as const;
type TabId = typeof TAB_IDS[keyof typeof TAB_IDS];

type Props = {
  onAddProduct: (product: Product) => void;
  onAddBasket: (basket: Basket) => void;
  onAddVirtual: (item: VirtualToAdd) => void;
};

const useStyles = makeStyles({
  catalog: {
    display: 'flex',
    flexDirection: 'row',
    gap: '2rem',
  },

  addProductsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
    width: '75%',
  },

  addVirtualProductsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
    width: '25%',

    '& > h4': {
      margin: 0,
      opacity: 0.7,
    },
  },

  productsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
    padding: '0.75rem',
  },
});

export function CatalogContainer({ onAddProduct, onAddBasket, onAddVirtual }: Props) {
  const classes = useStyles();
  const [currentTabId, setCurrentTabId] = useState<TabId>(TAB_IDS.PRODUCTS);

  const handleTabChange = (tabId: string) => {
    setCurrentTabId(tabId === TAB_IDS.PRODUCTS ? TAB_IDS.PRODUCTS : TAB_IDS.BASKETS);
  };

  return (
    <section className={classes.catalog}>
      <div className={classes.addProductsContainer}>
        <h4>Catalogue</h4>
        <Paper className={classes.productsContainer}>
          <TabsController
            size="small"
            tabs={[
              { id: TAB_IDS.PRODUCTS, label: 'Produits', value: TAB_IDS.PRODUCTS },
              { id: TAB_IDS.BASKETS, label: 'Paniers', value: TAB_IDS.BASKETS },
            ]}
            currentTabId={currentTabId}
            onTabChange={handleTabChange}
          />
          {currentTabId === TAB_IDS.PRODUCTS && <CatalogProductsList onAdd={onAddProduct} />}
          {currentTabId === TAB_IDS.BASKETS && <CatalogBasketsList onAdd={onAddBasket} />}
        </Paper>
      </div>

      <div className={classes.addVirtualProductsContainer}>
        <h4>Hors catalogue</h4>
        <AddVirtualProductForm onAdd={onAddVirtual} />
      </div>
    </section>
  );
}
